import { Injectable } from '@angular/core';
import { BaseService, LeagueApi, Tournament, TournamentSeason } from '@mtgame/core';
import { LeagueRootService } from '@core/services/league-root.service';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const STORE_TOURNAMENTS_KEY = 'tournaments';
const STORE_SEASONS_KEY = 'seasons';
const STORE_SEASON_ID_KEY = 'seasonId';
const STORE_SEARCH_KEY = 'search';


@Injectable({providedIn: 'root'})
export class LeagueTournamentsService extends BaseService {
  private leagueId: number;

  get seasons$(): Observable<TournamentSeason[]> {
    return this.store.get(STORE_SEASONS_KEY);
  }

  get tournaments$(): Observable<Tournament[]> {
    return combineLatest([
      this.store.get(STORE_TOURNAMENTS_KEY),
      this.store.get(STORE_SEASON_ID_KEY, null),
      this.store.get(STORE_SEARCH_KEY, '')
    ]).pipe(map(([tournaments, seasonId, query]) =>
      tournaments.filter(item =>
        (!seasonId || item.season.id === seasonId) &&
        (!query || item.name.toLowerCase().indexOf(query.toLowerCase()) > -1)
      )
    ));
  }

  constructor(
    private leagueApi: LeagueApi,
    private leagueRootService: LeagueRootService,
  ) {
    super();
  }

  async initialize(): Promise<any> {
    const league = this.leagueRootService.getLeagueModel();
    this.leagueId = league.id;
    return await Promise.all([
      this.getTournaments(),
      this.getSeasons(),
    ]);
  }

  async getTournaments(): Promise<Tournament[]> {
    let tournaments = await this.leagueApi.getTournaments(this.leagueId);
    tournaments = tournaments.sort((a, b) => a.date > b.date ? -1 : 1);
    this.store.save(STORE_TOURNAMENTS_KEY, tournaments);
    return tournaments;
  }

  async getSeasons(): Promise<TournamentSeason[]> {
    const seasonsPaginated = await this.leagueApi.getSeasons(this.leagueId);
    this.store.save(STORE_SEASONS_KEY, seasonsPaginated.data);
    return seasonsPaginated.data;
  }

  setSeasonId(seasonId: number): void {
    this.store.save(STORE_SEASON_ID_KEY, seasonId);
  }

  setSearch(query: string): void {
    this.store.save(STORE_SEARCH_KEY, query);
  }
}
